import { RouterProvider } from 'react-router';
import { router } from './routes/router';
import { useSessionBootstrap } from './lib/session-bootstrap';

export default function App() {
  // Uma renovação pelo cookie por carregamento; a montagem dupla do StrictMode recebe a mesma.
  useSessionBootstrap();
  return <RouterProvider router={router} />;
}
